import type { TreasuryPaymentsPrice } from '../../../__generated/treasury/types';
import type { PaymentV2ProductXPBoosterFragment } from '../_gql/fragments/__generated/payment-v2-product-xp-booster.fragment.gql.generated';
import type { ProductXPBoosterI } from '../payment.types';

export const processProductXPBooster = (
  rawProduct: PaymentV2ProductXPBoosterFragment,
  price: Pick<TreasuryPaymentsPrice, 'id' | 'basePrice'>,
  battlePassId: string
) => {
  const product: ProductXPBoosterI = {
    __typename: 'TreasuryProductXPBooster',
    id: rawProduct.id,
    name: rawProduct.name || '',
    description: rawProduct.description || '',
    price: {
      id: price.id,
      basePrice: {
        amount: price.basePrice.amount,
        currency: price.basePrice.currency,
      },
    },
    battlePassId,
  };
  return product;
};
